export enum McaApplicationType {
    PWA,
    MTA,
    BW,
}
